<router-outlet></router-outlet>
<div *ngIf="this.showLoaderSubject">
    <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
        <p style="font-size: 20px; color: white">Please Wait...</p>
    </ngx-spinner>
</div>